'use client';

import { createContext, useContext } from 'react';

/** The open state of the checkout's showing info ("Details"), owned by the booking page. */
export type CheckoutShowingInfo = { isOpen: boolean; close: () => void };

export const CheckoutShowingInfoContext = createContext<CheckoutShowingInfo>({ isOpen: false, close: () => undefined });

/** For the app's showing info modal inside the booking page: whether "Details" has opened it, and how to close it. */
export function useCheckoutShowingInfo(): CheckoutShowingInfo {
    return useContext(CheckoutShowingInfoContext);
}
